import { Button, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface EconsultCategoryDeleteConfirmationProps {
  isOpen: boolean;
  onContinue: () => void;
  onCancel: () => void;
}

const EconsultCategoryDeleteConfirmation: FC<EconsultCategoryDeleteConfirmationProps> = ({
  isOpen,
  onContinue,
  onCancel
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen}>
      <DialogTitle variant="h2" sx={{ color: 'primary.main' }}>
        {t('ClinicalReports.deleteConfirmation')}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ color: 'base.grey4' }}>
          {t('ClinicalReports.deleteConfirmationMessage')}
        </Typography>
        <Stack direction="row" columnGap={2} mt={2} justifyContent="flex-end">
          <Button size="large" variant="contained" onClick={onContinue}>
            {t('ClinicalReports.confirm')}
          </Button>
          <Button size="large" variant="contained" onClick={onCancel}>
            {t('ClinicalReports.cancel')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default EconsultCategoryDeleteConfirmation;
